import React from 'react';
import './ThemeSwitch.css';

export interface ThemeSwitchProps {
    /** When true, daytime (sun) is shown. When false, nighttime (moon + stars). */
    checked: boolean;
    onChange: (next: boolean) => void;
    /** ARIA label for the switch (the underlying input). */
    label?: string;
    className?: string;
    disabled?: boolean;
}

const CloudSvg: React.FC = () => (
    <svg className="theme-cloud" viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            d="M81 39c-1.7 0-3.4.3-5 .8C74.5 31.5 67 25 58 25c-9.7 0-17.7 7.6-18.4 17.1C36.4 41.4 33.3 41 30 41c-9.4 0-17 7.6-17 17 0 .3 0 .7.1 1H88c.3-1.6.5-3.3.5-5 0-8.3-6.7-15-15-15h7.5z"
            fill="#ffffff"
        />
    </svg>
);

export const ThemeSwitch: React.FC<ThemeSwitchProps> = ({
    checked,
    onChange,
    label = 'Activer le mode jour',
    className = '',
    disabled = false,
}) => {
    return (
        <label className={`theme-switch ${className}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                aria-label={label}
                disabled={disabled}
            />
            <span className="theme-slider">
                <div className="theme-star theme-star_1" />
                <div className="theme-star theme-star_2" />
                <div className="theme-star theme-star_3" />
                <CloudSvg />
            </span>
        </label>
    );
};

export default ThemeSwitch;
